import React, { useState, useEffect } from 'react';
import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "./firebase";

const Migrate = () => {
    const [authId, setAuthId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [user, loading] = useAuthState(auth);
    useEffect(() => {
        if(loading) {
            return;
        }
        const getAuthId = async () => {
            if (user) {
                    const token = await user.getIdToken()
                    setAuthId(token);
                    setIsLoading(false);
            }else{
                setIsLoading(false);
            }
        };

        getAuthId();
    }, [user, loading]);

    // Open universal link with auth token
    const openAutoLoginLink = () => {
        if (!authId) {
            showSnackbar('Authentication token not available');
            return;
        }

        const url = `https://gsc.app/universal-login-web/${authId}`;

        try {
            window.open(url, '_blank');
        } catch (error) {
            showSnackbar('Could not open the login page');
        }
    };

    // Simple snackbar function
    const showSnackbar = (message) => {
        // In a real app, you'd implement a proper snackbar/toast
        // This is a simple alert for demo purposes
        alert(message);
    };

    return (
        <div className="migrate-container">
            <header className="app-header">
                <h1>Account Migration</h1>
            </header>

            <div className="migrate-content">
                {isLoading ? (
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div className="migration-steps">
                        <div className="app-icon">
                            <div className="icon-container">
                                <i className="sync-icon">↻</i>
                            </div>
                        </div>

                        <h2 className="migration-title">Account Migration</h2>

                        <p className="migration-instructions">
                            Click the button below to automatically transfer your account to the GSC App.
                        </p>

                        <div className="login-button-container">
                            <button
                                className="primary-button"
                                onClick={openAutoLoginLink}
                                disabled={!authId}
                            >
                                {user ? 'Transfer My Account' :'You must be logged in to transfer your account' }
                            </button>
                        </div>

                        <div className="support-section">
                            <p>Need help? Contact our support team:</p>
                            <a
                                href="mailto:it@gardenspotcommunities.org"
                                className="support-link"
                            >
                                it@gardenspotcommunities.org
                            </a>
                        </div>
                    </div>
                )}
            </div>

            <style jsx>{`
                .migrate-container {
                    font-family: Arial, sans-serif;
                    max-width: 600px;
                    margin: 0 auto;
                }

                .app-header {
                    padding: 16px;
                    background-color: #f0f0f0;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    text-align: center;
                }

                .app-header h1 {
                    margin: 0;
                    font-size: 20px;
                }

                .migrate-content {
                    padding: 24px;
                }

                .loading-spinner {
                    display: flex;
                    justify-content: center;
                    padding: 40px 0;
                }

                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    border-radius: 50%;
                    border-top: 4px solid #3498db;
                    width: 40px;
                    height: 40px;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .app-icon {
                    display: flex;
                    justify-content: center;
                    margin: 24px 0;
                }

                .icon-container {
                    width: 120px;
                    height: 120px;
                    background-color: #f0f0f0;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .sync-icon {
                    font-size: 60px;
                    color: #3498db;
                }

                .migration-title {
                    font-size: 24px;
                    font-weight: bold;
                    text-align: center;
                    margin-bottom: 24px;
                }

                .migration-instructions {
                    text-align: center;
                    font-size: 16px;
                    margin-bottom: 48px;
                }

                .login-button-container {
                    display: flex;
                    justify-content: center;
                    margin: 48px 0;
                }

                .primary-button {
                    background-color: #3498db;
                    color: white;
                    border: none;
                    border-radius: 8px;
                    padding: 16px 32px;
                    font-size: 18px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    font-weight: bold;
                }

                .primary-button:hover {
                    background-color: #2980b9;
                }

                .primary-button:disabled {
                    background-color: #a0a0a0;
                    cursor: not-allowed;
                }

                .support-section {
                    margin-top: 48px;
                    text-align: center;
                }

                .support-link {
                    color: #3498db;
                    text-decoration: none;
                }

                .support-link:hover {
                    text-decoration: underline;
                }
            `}</style>
        </div>
    );
};

export default Migrate;
